import React, { useEffect, useState } from "react";
import { AgGridReact } from "ag-grid-react/lib/agGridReact";
import { openNotification } from "swfrontend/COMS/NotificationMessageMapping";
import ListFooter from "swfrontend/MDM/MDMScreens/ListView/ListFooter.js";
import ListHeader from "swfrontend/MDM/MDMScreens/ListView/ListHeader";
import { localStorageVariableName, route_url } from "swfrontend/AppConfigs";
import {
    notificationMessage,
    openNotificationType,
    notificationTitle,
} from "swfrontend/MDM/MDMUIConfigs/MDMUIMappings";

let gridApi = null;
let gridHeight = window.innerHeight - 400 + "px";
const onFirstDataRendered = (params) => params.api.sizeColumnsToFit();
const onGridReady = (params) => {
    gridApi = params.api;
};

const OfferList = ({ history }) => {
    const [state, setState] = useState({
        selectedRow: null,
        rowData: null,
        pageSize: 20,
        searchQuery: null,
        filterQuery: null,
        total: 0,
        currentPage: 1,
    });

    useEffect(() => {
        // fetchGridData(state.currentPage);
    }, [state.currentPage]);

    const onChangeTab = (activeKey) => {
        gridApi.showLoadingOverlay();
        setState({ ...state, activeTab: activeKey });
    };

    const onPaginationChange = (page, pageSize) => {
        if (page === 0 || page === null) {
            page = 1;
        }
        gridApi.showLoadingOverlay();
        setState({ ...state, pageSize: pageSize, currentPage: page });
    };

    //   const fetchGridData = (pageNo) => {
    //     let values = "";
    //     if (pageNo !== null) {
    //       values = "?page=" + pageNo;
    //     }

    //     if (state.activeTab === "my_observation") {
    //       values += "&created_by=" + sCreatedBy + (values.includes("&filter=1") ? "" : "&filter=1")
    //       // values += "&created_by=" + sCreatedBy;
    //     }

    //     if (state.filterRisk !== "All") {
    //       values +=
    //         "&risk_potential=" +
    //         state.filterRisk +
    //         (values.includes("&filter=1") ? "" : "&filter=1");
    //     }

    //     if (state.filterStatus !== "All") {
    //       values +=
    //         "&status=" +
    //         state.filterStatus +
    //         (values.includes("&filter=1") ? "" : "&filter=1");
    //     }

    //     if (state.pageSize !== null) {
    //       values += "&pageSize=" + state.pageSize;
    //     }

    //     if (state.searchQuery !== null) {
    //       values += "&" + state.searchQuery;
    //     }

    //     if (state.filterQuery !== null) {
    //       values +=
    //         "&" +
    //         state.filterQuery +
    //         (values.includes("&filter=1") ? "" : "&filter=1");
    //     }
    //     dataProvider
    //       .getObservationsData(RC_OBSERVATION_API_PATH + values)
    //       .then((res) => {
    //         if (res.ok) {
    //           res.json().then((rowData) => {
    //             try {
    //               gridApi.hideOverlay();
    //             } catch (e) {}
    //             setState({
    //               ...state,
    //               total: rowData.total,
    //               rowData: rowData.results,
    //             });
    //             // setState({ total: rowData.total, rowData: rowData.results });
    //           });
    //         } else {
    //           res.json().then((responseJson) => {
    //             openNotification("error", "Error", responseJson["message"]);
    //           });
    //         }
    //       })
    //       .catch(() => {
    //         openNotification(
    //           openNotificationType.error,
    //           notificationTitle.api,
    //           notificationMessage.apiConnectionError
    //         );
    //       });
    //   };

    const handleNewButtonClick = () => {
        history.push(route_url.url + 'offer_received/new');
    };

    const handleFilterApply = (querystring) => {
        gridApi.showLoadingOverlay();
        setState({ ...state, filterQuery: querystring, currentPage: 1 });
    };

    const handleResetFilter = () => {
        gridApi.showLoadingOverlay();
        setState({
            ...state,
            selectedRow: null,
            filterQuery: null,
            currentPage: 1,
        });
    };

    const handleResetSearch = () => {
        gridApi.showLoadingOverlay();
        setState({ ...state, selectedRow: null });
    };

    const handleSearchApply = (value) => {
        gridApi.showLoadingOverlay();
        let quer_param = "search=" + value;
        if (value === "") {
            quer_param = null;
        }
        setState({ ...state, searchQuery: quer_param, currentPage: 1 });
    };

    return (
        <div className="col-md-12">
            <ListHeader
                excelExport={() => { }}
                showListHeader={true}
                addButton={true}
                columnFilterButton={false}
                // columnDefs={OBSERVATIONS_HEADER_COLUMNDEFS}
                onSearch={(q) => handleSearchApply(q)}
                onFilter={(q) => handleFilterApply(q)}
                onResetSearch={() => handleResetSearch()}
                onResetFilter={() => handleResetFilter()}
                addField={handleNewButtonClick}
            />
            <div className="grid-background">
                <div className="row">
                    <div className="col-md-12">
                        <div
                            id="grid"
                            className="table-responsive table-bordered table table-hover table-bordered results ag-theme-balham gridViewDisplay"
                            style={{ height: gridHeight }}
                        >
                            <AgGridReact
                                // columnDefs={OBSERVATIONS_COLUMNDEFS}
                                rowData={state.rowData}
                                pagination={false}
                                onGridReady={onGridReady}
                                onFirstDataRendered={onFirstDataRendered}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <ListFooter
                    total={state.total}
                    currentPage={state.currentPage}
                    onShowSizeChange={(pageNo, pageSize) =>
                        onPaginationChange(pageNo, pageSize)
                    }
                    onPaginationChange={(pageNo, pageSize) =>
                        onPaginationChange(pageNo, pageSize)
                    }
                />
            </div>
        </div>
    );
};

export default OfferList;
